// login.js
'use strict';
import addModal from '../action/addModal.js';
import pushToastr from '../action/pushToastr.js';
import getOperationData from '../selector/getOperationData.js';
import { login as loginModal } from '../resource/modalId.js';
import { getIsChinaPartner, getPartnerName } from '../resource/partner.js';
import i18n from '../resource/i18n.js';

/**
 * Login
 * @kind action
 * @return {Promise} Action promise.
 */
const login = () => (dispatch, getState) => {
  if (getIsChinaPartner()) {
    return dispatch(
      pushToastr({
        textKey: 're_login_on_partner',
        textKeyOption: {
          partnerName: i18n.t(getPartnerName()),
        },
        color: 'error',
      })
    );
  }

  const welcomeBackData = getOperationData(getState(), ['welcomeBack']);
  if (welcomeBackData?.userId) {
    return dispatch(
      addModal({
        id: loginModal.WELCOME_BACK,
        isHigherThanAll: true,
        transitionStatus: 'comingFromBottom',
      })
    );
  }

  return dispatch(
    addModal({
      id: loginModal.METHOD_SELECT,
      isHigherThanAll: true,
      transitionStatus: 'comingFromBottom',
    })
  );
};

export default login;
